import { render, staticRenderFns } from "./of_pagination.vue?vue&type=template&id=2370496f&scoped=true&"
import script from "./of_pagination.vue?vue&type=script&lang=js&"
export * from "./of_pagination.vue?vue&type=script&lang=js&"
import style0 from "./of_pagination.vue?vue&type=style&index=0&id=2370496f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2370496f",
  null
  
)

export default component.exports